import { render, staticRenderFns } from "./UsedMaterials.vue?vue&type=template&id=7099c316&scoped=true&"
import script from "./UsedMaterials.vue?vue&type=script&lang=js&"
export * from "./UsedMaterials.vue?vue&type=script&lang=js&"
import style0 from "./UsedMaterials.vue?vue&type=style&index=0&id=7099c316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099c316",
  null
  
)

export default component.exports